import {
    InteractionLayerSizeV2,
    LayerManagerV2,
    ShimBackgroundTypeV2,
} from '@volkswagen-onehub/layer-manager'

import React from 'react'
import {Provider} from 'react-redux'
import {CouponRequestLayer} from '../CouponRequest'
import store from '../../../store'
import {
    setAutoloadedRFQForm,
    setFormPromotion,
    setPersonalData,
    showThanksPage,
} from '../../../../features/userData/userDataSlice'
import {Params} from '../../../../shared/variables'
import {
    setSelectedPromotion,
    setShowCouponLayer,
} from '../../../../features/general/generalSlice'
import {RootState} from '../../../rootReducer'
import {ThemedLayerProvider} from '../../../../shared/ThemedLayerProvider'

function couponRenderLayer(): React.JSX.Element {
    return (
        <Provider store={store}>
            <ThemedLayerProvider>
                <CouponRequestLayer />
            </ThemedLayerProvider>
        </Provider>
    )
}

let localLayerManager: LayerManagerV2
let layer: {close: () => void}

export const setCouponLayerHandle = (layerManager: LayerManagerV2) => {
    localLayerManager = layerManager
}

export const resetFormAfterSuccess = () => {
    store.dispatch(showThanksPage(false))
    store.dispatch(setPersonalData({}))
    store.dispatch(setSelectedPromotion(null))
}

export const openCouponLayer = () => {
    const state = store.getState() as RootState

    if (!localLayerManager || state.general.showCouponLayer) {
        return
    }

    store.dispatch(setShowCouponLayer(true))
    layer = localLayerManager.openInteractionLayer(
        couponRenderLayer,
        {},
        {
            'size': InteractionLayerSizeV2.E,
            'shimBackgroundType': ShimBackgroundTypeV2.OPAQUE,
            'aria-labelledby': 'coupon-request-layer-title',
            'userCloseable': true,
            'onClose': () => {
                store.dispatch(setShowCouponLayer(false))
                store.dispatch(setAutoloadedRFQForm(false))
                store.dispatch(setFormPromotion(null))
                resetFormAfterSuccess()
                const searchParams = new URLSearchParams(window.location.search)
                searchParams.delete(Params.SHOW_FORM)
                searchParams.delete(Params.PROMOTION)

                const newSearch = searchParams.toString()
                const newPath =
                    window.location.pathname +
                    (newSearch ? `?${newSearch}` : '')

                window.history.replaceState({}, '', newPath)
            },
        }
    )
}

export const closeCouponLayer = () => {
    const state = store.getState() as RootState

    if (!layer || !state.general.showCouponLayer) {
        return
    }
    layer.close()
}
